import { AuthorizationError } from '../errors';

export const isAuthorizationError = (error: unknown): error is AuthorizationError => {
    return error instanceof AuthorizationError;
};
